module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage"
  }, [_c('a', {
    attrs: {
      "id": "title41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_vm._v("Foul deeds will rise,"), _c('br'), _vm._v(" Though all the earth o’erwhelm them, to men’s eyes.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—WILLIAM SHAKESPEARE"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hamlet")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_vm._v("Be not deceived; God is not mocked:"), _c('br'), _vm._v(" For whatsoever a man soweth,"), _c('br'), _vm._v(" That shall he also reap.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—Galatians, Chapter 6, Verse 7")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab2ead4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429997973_epi01.vue
// module id = 69
// module chunks = 0